class marmetoProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.initEvent();
  }

  initEvent(){
    let swatchs = this.querySelectorAll(".color-swatch");
    let _this = this;

    console.log(this.querySelectorAll(".color-swatch"));
    if(swatchs.length > 0){
      swatchs.forEach((swatch)=>{
        swatch.addEventListener('click',(e)=>{
          e.preventDefault();
          let productUrl = e.target.getAttribute("data-href");
          console.log(productUrl)
          _this.onVariantChange(productUrl);
        })
      })
    }
  }

  onVariantChange(productUrl) {
    this.renderProductCard(productUrl);
  }

  async renderProductCard(productUrl) {
    this.productCard = this.closest('marmeto-product-card');
    this.sectionId = this.productCard.dataset.sectionId;
    this.productHandle = this.productCard.dataset.productHandle;
    this.templateParam = this.closest('multi-product-form') ? 'card-complementary' : 'card';
    let variantUrl = `${productUrl}&section_id=product-card`;
  
    try {
      // Fetch the data
      const response = await fetch(variantUrl);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const responseCard = html.querySelector('marmeto-product-card');
       
      this.productCard.innerHTML = responseCard.innerHTML;
      this.initEvent(productUrl);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

}

customElements.define('marmeto-product-card', marmetoProductCard);